// The password rules from spec C1 as the checklist on screen: at least 12 characters, not your email,
// both passwords match. The server checks the same rules (apps/server/src/auth/password-rules.ts);
// keep the two in step.

export const minPasswordLength = 12;
export const maxPasswordLength = 128;

// Letters and digits only, lower case, so "Gittel.Weber!2026" still counts as containing "gittelweber".
const bare = (value: string) => value.toLowerCase().replace(/[^a-z0-9]/g, '');

export type PasswordRule = { label: string; ok: boolean };

export function passwordRules(password: string, confirm: string, email: string): PasswordRule[] {
  const pw = bare(password);
  const local = bare(email.split('@')[0] ?? '');
  const full = bare(email);
  return [
    {
      label: 'At least 12 characters',
      ok: password.length >= minPasswordLength && password.length <= maxPasswordLength,
    },
    {
      label: 'Not your email',
      ok: pw !== '' && (local === '' || !pw.includes(local)) && !pw.includes(full),
    },
    { label: 'Both passwords match', ok: confirm !== '' && password === confirm },
  ];
}
